module.exports = __webpack_public_path__ + "bottomText-white-bg.png?e813c1ca50bf98824c9c4db36de53f70";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/bottomText-white-bg.png
// module id = 5
// module chunks = 0